import { createApp } from 'vue';
import { createPinia } from 'pinia';
import AgentApp from './modules/Agents/AgentApp.vue';
import 'vuetify/styles';
import Vuetify from './plugins/vuetify';

const el = document.getElementById('agent-app');
if (el) {
    const pinia = createPinia();
    createApp(AgentApp)
        .use(Vuetify)
        .use(pinia)
        .mount('#agent-app');
}
